import React from 'react';
import Form from '../../../../components/form/Form';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import { connect } from 'react-redux';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../redux/store';
import Textarea from '../../../../components/input/floating-label/textarea/Textarea';
import {
  setDispohinweis,
  setHinweis,
  setZollvermerk,
} from '../../../../redux/actions/auftragserfassung';
import Spotpreis from './spotpreis/Spotpreis';

interface HinweiseProps {
  auftragserfassung: StateModel_Auftragserfassung;
  setHinweis: (value: string | undefined) => void;
  setDispohinweis: (value: string | undefined) => void;
  setZollvermerk: (value: string | undefined) => void;
  kunde: string | undefined;
}

const Hinweise = (props: HinweiseProps) => {
  return (
    <GridCellWrapper
      classes='hinweise noSelect'
      label='Hinweise'
      saveUserAnsicht={() => {
        null;
      }}
    >
      <Form classes='hinweise'>
        {props.kunde != 'BEXITY' && (
          <Textarea
            label='Dispohinweis'
            name='dispohinweis'
            classes='dispohinweis'
            maxLength={70}
            maxLineBreaks={5}
            value={props.auftragserfassung?.dispohinweis ?? ''}
            onChangeHandler={props.setDispohinweis}
          />
        )}
        <Textarea
          label='Hinweis'
          name='hinweis'
          classes='hinweis'
          maxLength={4000}
          maxLineBreaks={5}
          value={props.auftragserfassung.hinweis ?? ''}
          onChangeHandler={props.setHinweis}
        />
        {props.kunde == 'BEXITY' && (
          <Textarea
            label='Zollvermerk'
            name='zollvermerk'
            classes='zollvermerk'
            maxLength={100}
            maxLineBreaks={5}
            value={props.auftragserfassung.zollvermerk ?? ''}
            onChangeHandler={props.setZollvermerk}
          />
        )}

        {props.kunde == 'BEXITY' && <Spotpreis />}
      </Form>
    </GridCellWrapper>
  );
};

const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
  kunde: state.Config.clientKunde,
});

export default connect(mapStateToProps, {
  setHinweis,
  setDispohinweis,
  setZollvermerk,
})(Hinweise);
